import styled from "styled-components";
import { Box } from "@mui/system";

export const KcalContainer = styled(Box)`
    &.MuiBox-root{
        margin-left: 1.2rem;
        color: #656870;
    }`
    
